import "./EnhancedButtonPrimeReact.css"

import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';
import React from 'react';
import { useTheme } from '@mui/material/styles';

export interface IEnhancedButtonPrimeReact {
  label?: string;
  icon?: React.ReactNode;
  loading?: boolean;
  onClickHandler?: () => void;
  iconPos?: 'left' | 'right' | 'top' | 'bottom';
  severity?: 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'help' | 'contrast';
  disabled?: boolean;
  raised?: boolean;
  rounded?: boolean;
  text?: boolean;
  outlined?: boolean;
  badge?: string;
  badgeClassName?: string;
  size?: 'small' | 'large';
  type?: 'submit' | 'reset' | 'button';
  style?: React.CSSProperties;  // Updated to React.CSSProperties for proper type
  className?:string,
  to?:string;
  tooltip?:any;
  tooltipOptions?:any;
}

export const EnhancedButtonPrimeReact: React.FC<IEnhancedButtonPrimeReact> = ({
  label,
  icon,
  iconPos = "left",
  severity,
  disabled,
  raised,   
  rounded,    
  text,             
  outlined,        
  badge,
  badgeClassName,
  size = "small",
  type = 'button',
  loading,
  onClickHandler,
  style,
  className,
  tooltip,
  tooltipOptions,
  to
}) => {
  const theme = useTheme();
  return (
    <Button
      label={!to ? label : undefined}
      icon={icon && icon}
      iconPos={iconPos && iconPos}
      loading={loading && loading}
      onClick={onClickHandler && onClickHandler}
      severity={severity && severity}
      disabled={disabled && disabled}
      raised={raised && raised}
      rounded={rounded && rounded}
      text={text && text}
      outlined={outlined && outlined}
      badge={badge && badge}
      badgeClassName={badgeClassName && badgeClassName}
      size={size && size}
      type={type && type}  
      tooltip={tooltip && tooltip}  
      tooltipOptions={tooltipOptions && tooltipOptions}  
      style={{ ...style, borderRadius: rounded ? undefined : "2px",padding:to ? "0.53rem 1.09375rem" : rounded ? "0.65625rem 1.09375rem" : "0.5rem 1.59375rem" }}
      className={className}
    >
      {to && <Link to={to} style={{color:"#fff",textDecoration:"none"}} >{label}</Link>}
    </Button>
  );
};